import React from 'react';
import { faEye, faUsers, faUserGroupCrown } from '@fortawesome/pro-regular-svg-icons';
import { faChartUser } from '@fortawesome/pro-solid-svg-icons';
import { useParams } from 'react-router-dom';
import { useGetStatsSummaryQuery } from 'src/features/manage-room/manage-room.slice';
import { StyledChartUserIcon, StyledStatContainer, StyledStatHeadingContainer, StyledStatHeadingText, StyledStatIcon, StyledStatText, StyledStatsInfoCardContainer } from './stats-info-card.styles';
const StatsInfoCard = () => {
  const {
    roomCode
  } = useParams();
  if (!roomCode) throw new Error('No roomCode in url params');
  const {
    data
  } = useGetStatsSummaryQuery(roomCode);
  const views = data?.views ?? 0;
  const users = data?.users ?? 0;
  const completed = data?.noCompletedUsers ?? 0;
  return <StyledStatsInfoCardContainer aria-label="Stats Info Card" data-sentry-element="StyledStatsInfoCardContainer" data-sentry-component="StatsInfoCard" data-sentry-source-file="stats-info-card.tsx">
      <StyledStatContainer data-sentry-element="StyledStatContainer" data-sentry-source-file="stats-info-card.tsx">
        <div>
          <StyledStatHeadingContainer data-sentry-element="StyledStatHeadingContainer" data-sentry-source-file="stats-info-card.tsx">
            <StyledStatIcon icon={faEye} data-sentry-element="StyledStatIcon" data-sentry-source-file="stats-info-card.tsx" />
            <StyledStatHeadingText data-sentry-element="StyledStatHeadingText" data-sentry-source-file="stats-info-card.tsx">Views</StyledStatHeadingText>
          </StyledStatHeadingContainer>
          <StyledStatText data-sentry-element="StyledStatText" data-sentry-source-file="stats-info-card.tsx">{views}</StyledStatText>
        </div>

        <div>
          <StyledStatHeadingContainer data-sentry-element="StyledStatHeadingContainer" data-sentry-source-file="stats-info-card.tsx">
            <StyledStatIcon icon={faUsers} data-sentry-element="StyledStatIcon" data-sentry-source-file="stats-info-card.tsx" />
            <StyledStatHeadingText data-sentry-element="StyledStatHeadingText" data-sentry-source-file="stats-info-card.tsx">Users</StyledStatHeadingText>
          </StyledStatHeadingContainer>
          <StyledStatText data-sentry-element="StyledStatText" data-sentry-source-file="stats-info-card.tsx">{users}</StyledStatText>
        </div>

        <div>
          <StyledStatHeadingContainer data-sentry-element="StyledStatHeadingContainer" data-sentry-source-file="stats-info-card.tsx">
            <StyledStatIcon icon={faUserGroupCrown} data-sentry-element="StyledStatIcon" data-sentry-source-file="stats-info-card.tsx" />
            <StyledStatHeadingText data-sentry-element="StyledStatHeadingText" data-sentry-source-file="stats-info-card.tsx">Completed</StyledStatHeadingText>
          </StyledStatHeadingContainer>
          <StyledStatText data-sentry-element="StyledStatText" data-sentry-source-file="stats-info-card.tsx">{completed}</StyledStatText>
        </div>
      </StyledStatContainer>

      <StyledChartUserIcon icon={faChartUser} data-sentry-element="StyledChartUserIcon" data-sentry-source-file="stats-info-card.tsx" />
    </StyledStatsInfoCardContainer>;
};
export const MemoizedStatsInfoCard = React.memo(StatsInfoCard);